import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/orchestra/")({
  component: () => null,
  beforeLoad() {
    throw redirect({ to: "/app/duties/orchestra" })
  },
})
